import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeletePinInputClass;
function DeletePinInput() {
  if (DeletePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId) {
        this.s6p_1 = partyId;
        this.t6p_1 = pinId;
      }
      toString() {
        return 'DeletePinInput(partyId=' + this.s6p_1.toString() + ', pinId=' + this.t6p_1.toString() + ')';
      }
      hashCode() {
        var result = this.s6p_1.hashCode();
        result = imul(result, 31) + this.t6p_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePinInput()))
          return false;
        if (!this.s6p_1.equals(other.s6p_1))
          return false;
        if (!this.t6p_1.equals(other.t6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePinInput');
    DeletePinInputClass = $;
  }
  return DeletePinInputClass;
}
//region block: exports
export {
  DeletePinInput as DeletePinInputmel7ixrs09hz,
};
//endregion

//# sourceMappingURL=DeletePinInput.mjs.map
